import React, { Component } from "react";

class Footer extends Component {
  render() {
    return <footer className="footer">Created by Francsy</footer>;
  }
}

export default Footer;
